type Node = {
    id: string;
    props: {
        children: Node[];
    };
}

export const changeIDsRecursively = (node: Node) => {
  node.id = crypto.randomUUID();
  if (node.props.children) {
    node.props.children.forEach((child: Node) =>
      changeIDsRecursively(child)
    );
  };
};